import api from './api';
import { IParticipante } from '../common/interfaces/participante.interface';

export function obterParticipante(): Promise<IParticipante> {
    return api.get('/participante').then(res => res.data);
}
